(() => {
  if (window.MaxFreshPersonalization) return;
  const root = () => window.Shopify?.routes?.root || '/';
  const strings = JSON.parse(document.getElementById('mf-personalization-strings')?.textContent || '{}');
  const components = () => [...document.querySelectorAll('mf-personalization')];
  const find = form => {
    const formId = form?.getAttribute?.('id');
    if (!formId) return undefined;
    return components().find(el => el.dataset.form === formId || formId === `product-form-sticky-${el.dataset.section}`);
  };
  const api = {
    strings,
    validate(form) {
      const el = find(form);
      if (!el?.active) return true;
      if (!el.dataset.fee || el.price() <= 0) {
        el.showError(strings.price_error);
        el.panel.hidden = false;
        return false;
      }
      const qty = el.quantity();
      el.refresh(qty);
      if (!el.saved || el.saved.length !== qty) {
        el.showError(strings.required);
        el.panel.hidden = false;
        el.querySelector('input')?.focus();
        el.scrollIntoView({block: 'center', behavior: 'smooth'});
        return false;
      }
      return true;
    },
    prepare(form, original) {
      const el = find(form);
      if (!el?.active || !el.saved) return original;
      const group = crypto.randomUUID();
      const qty = el.saved.length;
      const feeQty = el.dataset.mode === 'per_group' ? 1 : qty;
      const result = new FormData();
      for (const [key, value] of original) {
        if (key === 'id' || key === 'quantity' || key === 'selling_plan' || key.startsWith('properties[')) {
          const nestedKey = key.startsWith('properties[') ? `items[0][properties][${key.slice(11)}` : `items[0][${key}]`;
          result.append(nestedKey, value);
        } else if (key !== 'add' && key !== 'form_type' && key !== 'utf8') {
          result.append(key, value);
        }
      }
      result.set('items[0][id]', original.get('id'));
      result.set('items[0][quantity]', String(qty));
      const props = {
        _mf_group: group, _mf_role: 'product', _mf_count: String(qty),
        _mf_fee_quantity: String(feeQty), _mf_fee_variant: el.dataset.fee,
        Personalization: 'Name engraving required'
      };
      el.saved.forEach((name, index) => { props[`Name ${index + 1}`] = name; });
      for (const [key, value] of Object.entries(props)) result.set(`items[0][properties][${key}]`, value);
      result.set('items[1][id]', el.dataset.fee);
      result.set('items[1][quantity]', String(feeQty));
      result.set('items[1][properties][_mf_group]', group);
      result.set('items[1][properties][_mf_role]', 'fee');
      result.set('items[1][properties][For]', document.getElementById(el.dataset.form)?.closest('.product-info')?.querySelector('h1')?.textContent.trim() || 'Personalized product');
      result.set('items[1][properties][Names]', el.saved.join(', '));
      return result;
    },
    async add(form) {
      const el = find(form);
      if (!el || el.busy) return false;
      if (!el.cartResolved) await el.lookupCart();
      if (el.lookupFailed || !api.validate(form)) return false;
      if (el.cartTarget) return api.attach(el);
      form = document.getElementById(el.dataset.form) || form;
      if (!form.reportValidity()) return false;
      const requiredOptions = [...(form.closest('.product-info')?.querySelectorAll('.customization-picker') || [])];
      const incomplete = requiredOptions.filter(input => (input.required && !input.value) || input.classList.contains('validate-checkbox'));
      if (incomplete.length) {
        incomplete.forEach(input => input.classList.add('required-picker'));
        el.panel.hidden = false;
        el.showError(strings.required_options);
        return false;
      }
      const prepared = api.prepare(form, new FormData(form));
      const items = [{properties: {}}, {properties: {}}];
      let hasFiles = false;
      for (const [key, value] of prepared) {
        const match = key.match(/^items\[(\d+)\]\[(id|quantity|selling_plan|properties)\](?:\[(.*)\])?$/);
        if (!match) continue;
        const [, index, field, property] = match;
        const item = items[Number(index)];
        if (value instanceof File && !value.size) continue;
        if (field === 'selling_plan' && !value) continue;
        if (value instanceof File && value.size > 0) hasFiles = true;
        if (field === 'properties') item.properties[property] = value;
        else item[field] = Number(value);
      }
      const group = items[0].properties._mf_group;
      const names = el.saved.slice();
      const giftCheckbox = form.closest('.product-info')?.querySelector('[x-ref="gift_wrapping_checkbox"]');
      if (giftCheckbox?.checked && el.dataset.giftFee) {
        items.push({id: Number(el.dataset.giftFee), quantity: 1, properties: {_mf_group: group, _mf_role: 'gift'}});
      }
      const helper = window.Alpine?.store('xCartHelper');
      const sections = helper?.getSectionsToRender?.().slice(0, 5) || [];
      let body;
      const headers = {Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest'};
      if (hasFiles) {
        if (items[2]) {
          prepared.set('items[2][id]', String(items[2].id));
          prepared.set('items[2][quantity]', '1');
          prepared.set('items[2][properties][_mf_group]', group);
          prepared.set('items[2][properties][_mf_role]', 'gift');
        }
        if (sections.length) prepared.set('sections', sections.map(section => section.id).join(','));
        prepared.set('sections_url', location.pathname);
        body = prepared;
      } else {
        headers['Content-Type'] = 'application/json';
        body = JSON.stringify({items, sections: sections.map(section => section.id), sections_url: location.pathname});
      }
      el.setBusy(true);
      let attempted = false;
      try {
        attempted = true;
        const response = await fetch(`${root()}cart/add.js`, {method: 'POST', headers, body});
        const result = await response.json();
        if (!response.ok || result.status >= 400 || result.errors) throw new Error(result.description || strings.add_error);
        const cartResponse = await fetch(`${root()}cart.js`, {headers: {Accept: 'application/json'}, cache: 'no-store'});
        if (!cartResponse.ok) throw new Error(strings.check_cart);
        const cart = await cartResponse.json();
        const linked = cart.items.filter(line => line.properties?._mf_group === group);
        const products = linked.filter(line => line.properties._mf_role === 'product');
        const fees = linked.filter(line => line.properties._mf_role === 'fee');
        const count = lines => lines.reduce((total, line) => total + line.quantity, 0);
        if (!products.length || !fees.length || count(products) !== items[0].quantity || count(fees) !== items[1].quantity) throw new Error(strings.add_error);
        if (fees.some(fee => Number(fee.original_price ?? fee.price) !== el.price())) throw new Error(strings.price_changed);
        const summary = el.querySelector('[data-mf-summary]');
        (summary.querySelector('[data-mf-summary-text]') || summary).textContent = `${strings.added}: ${names.join(', ')} · ${el.money(el.price() * items[1].quantity)}`;
        summary.hidden = false;
        if (products.length === 1) {
          el.cartTarget = products[0];
          el.existingPaid = true;
          el.updateCartContext();
        }
        if (giftCheckbox) giftCheckbox.checked = false;
        try {
          sections.forEach(section => {
            const target = document.querySelector(section.selector);
            if (target && result.sections?.[section.id]) {
              const html = new DOMParser().parseFromString(result.sections[section.id], 'text/html');
              const replacement = html.querySelector(section.selector);
              if (replacement) target.innerHTML = replacement.innerHTML;
            }
          });
          if (helper) helper.currentItemCount = cart.item_count;
          document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
          const drawer = window.Alpine?.store('xMiniCart');
          if (drawer?.openCart && sections.length) drawer.openCart();
          else location.assign(`${root()}cart`);
        } catch {
          location.assign(`${root()}cart`);
        }
        return true;
      } catch (error) {
        if (attempted) {
          try {
            const cartResponse = await fetch(`${root()}cart.js`, {headers: {Accept: 'application/json'}, cache: 'no-store'});
            if (!cartResponse.ok) throw new Error();
            const cart = await cartResponse.json();
            const updates = {};
            cart.items.filter(line => line.properties?._mf_group === group).forEach(line => { updates[line.key] = 0; });
            if (Object.keys(updates).length) {
              const cleanup = await fetch(`${root()}cart/update.js`, {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({updates})});
              if (!cleanup.ok) throw new Error();
            }
          } catch {
            el.panel.hidden = false;
            el.showError(strings.check_cart);
            return false;
          }
        }
        el.panel.hidden = false;
        el.showError(error.message || strings.add_error);
        return false;
      } finally {
        el.setBusy(false);
      }
    },
    async readCart() {
      const response = await fetch(`${root()}cart.js`, {headers: {Accept: 'application/json'}, cache: 'no-store'});
      if (!response.ok) throw new Error(strings.check_cart);
      return response.json();
    },
    async post(path, body) {
      const response = await fetch(`${root()}${path}`, {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify(body)});
      const result = await response.json();
      if (!response.ok || result.status >= 400 || result.errors) throw new Error(result.description || strings.existing_error);
      return result;
    },
    async attach(el) {
      if (!el.cartTarget || !el.saved || el.lookupFailed) {
        el.panel.hidden = false;
        el.showError(strings.cart_changed);
        return false;
      }
      const names = el.saved.slice();
      const target = el.cartTarget;
      const group = target.properties?._mf_group || crypto.randomUUID();
      const feeQty = el.dataset.mode === 'per_group' ? 1 : names.length;
      const helper = window.Alpine?.store('xCartHelper');
      const sections = helper?.getSectionsToRender?.().slice(0, 5) || [];
      const sectionData = {sections: sections.map(section => section.id), sections_url: location.pathname};
      let original = null;
      let oldFees = [];
      let propertiesAttempted = false;
      let feeAttempted = false;
      let appliedProperties = {};
      el.setBusy(true);
      try {
        const before = await api.readCart();
        const line = before.items.find(item => item.key === target.key);
        if (!line || line.quantity !== names.length || Number(line.variant_id || line.id) !== el.variantId()) throw new Error(strings.cart_changed);
        original = {...(line.properties || {})};
        const existingGroup = original._mf_group;
        oldFees = existingGroup ? before.items.filter(item => item.properties?._mf_group === existingGroup && item.properties?._mf_role === 'fee') : [];
        if (existingGroup && before.items.filter(item => item.properties?._mf_group === existingGroup && item.properties?._mf_role === 'product').length !== 1) throw new Error(strings.cart_changed);
        if (oldFees.length && (oldFees.reduce((total, fee) => total + fee.quantity, 0) !== feeQty || oldFees.some(fee => Number(fee.variant_id || fee.id) !== Number(el.dataset.fee) || Number(fee.original_price ?? fee.price) !== el.price()))) throw new Error(strings.price_changed);
        appliedProperties = {...original, _mf_group: group, _mf_role: 'product', _mf_count: String(names.length), _mf_fee_quantity: String(feeQty), _mf_fee_variant: el.dataset.fee, Personalization: 'Name engraving required'};
        names.forEach((name, index) => { appliedProperties[`Name ${index + 1}`] = name; });
        propertiesAttempted = true;
        let result = await api.post('cart/change.js', {id: line.key, quantity: line.quantity, properties: appliedProperties, ...sectionData});
        if (oldFees.length) {
          for (const fee of oldFees) {
            result = await api.post('cart/change.js', {id: fee.key, quantity: fee.quantity, properties: {...fee.properties, Names: names.join(', ')}, ...sectionData});
          }
        } else {
          feeAttempted = true;
          result = await api.post('cart/add.js', {items: [{id: Number(el.dataset.fee), quantity: feeQty, properties: {_mf_group: group, _mf_role: 'fee', For: line.product_title || line.title || 'Personalized product', Names: names.join(', ')}}], ...sectionData});
        }
        const cart = await api.readCart();
        const linked = cart.items.filter(item => item.properties?._mf_group === group);
        const product = linked.find(item => item.properties._mf_role === 'product');
        const fees = linked.filter(item => item.properties._mf_role === 'fee');
        if (!product || product.quantity !== line.quantity || names.some((name, i) => product.properties[`Name ${i + 1}`] !== name) || fees.reduce((total, fee) => total + fee.quantity, 0) !== feeQty) throw new Error(strings.existing_error);
        if (fees.some(fee => Number(fee.original_price ?? fee.price) !== el.price())) throw new Error(strings.price_changed);
        el.cartTarget = product;
        el.existingPaid = true;
        if (el.dataset.cartKey) {
          el.dataset.cartKey = product.key;
          el.dataset.group = group;
          el.dataset.paid = 'true';
        }
        const url = new URL(location.href);
        if (url.searchParams.has('mf_personalize')) {
          url.searchParams.delete('mf_personalize');
          history.replaceState(null, '', url.pathname + url.search + url.hash);
        }
        el.updateCartContext();
        const summary = el.querySelector('[data-mf-summary]');
        (summary.querySelector('[data-mf-summary-text]') || summary).textContent = oldFees.length ? `${strings.names_updated}: ${names.join(', ')}` : `${strings.updated}: ${names.join(', ')} · ${el.money(el.price() * feeQty)}`;
        summary.hidden = false;
        try {
          sections.forEach(section => {
            const element = document.querySelector(section.selector);
            if (element && result.sections?.[section.id]) {
              const html = new DOMParser().parseFromString(result.sections[section.id], 'text/html');
              const replacement = html.querySelector(section.selector);
              if (replacement) element.innerHTML = replacement.innerHTML;
            }
          });
          if (helper) helper.currentItemCount = cart.item_count;
          document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
          const drawer = window.Alpine?.store('xMiniCart');
          if (drawer?.openCart && sections.length) drawer.openCart();
          else if (!el.dataset.cartKey) location.assign(`${root()}cart`);
        } catch {
          if (!el.dataset.cartKey) location.assign(`${root()}cart`);
          else window.Alpine?.store('xMiniCart')?.reLoad?.();
        }
        return true;
      } catch (error) {
        if (propertiesAttempted || feeAttempted) {
          try {
            let cart = await api.readCart();
            if (feeAttempted) {
              const updates = {};
              cart.items.filter(item => item.properties?._mf_group === group && item.properties?._mf_role === 'fee').forEach(fee => { updates[fee.key] = 0; });
              if (Object.keys(updates).length) await api.post('cart/update.js', {updates});
            }
            cart = await api.readCart();
            const changed = cart.items.find(item => item.properties?._mf_group === group && item.properties?._mf_role === 'product' && Number(item.variant_id || item.id) === Number(target.variant_id || target.id));
            if (changed && original) {
              const restored = {...Object.fromEntries(Object.keys(appliedProperties).map(key => [key, ''])), ...original};
              await api.post('cart/change.js', {id: changed.key, quantity: changed.quantity, properties: restored});
            }
            if (oldFees.length) {
              cart = await api.readCart();
              for (const fee of cart.items.filter(item => item.properties?._mf_group === group && item.properties?._mf_role === 'fee')) {
                await api.post('cart/change.js', {id: fee.key, quantity: fee.quantity, properties: oldFees[0].properties});
              }
            }
            el.cartResolved = false;
          } catch {
            el.panel.hidden = false;
            el.showError(strings.check_cart);
            return false;
          }
        }
        el.panel.hidden = false;
        el.showError(error.message || strings.existing_error);
        return false;
      } finally { el.setBusy(false); }
    },
    async change(key, qty, sections) {
      const response = await fetch(`${root()}cart.js`, {headers: {Accept: 'application/json'}});
      if (!response.ok) throw new Error('Cart unavailable');
      const cart = await response.json();
      const item = cart.items.find(line => line.key === key);
      const group = item?.properties?._mf_group;
      if (!group) return fetch(`${root()}cart/change.js`, {
        method: 'POST', headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({id: key, quantity: qty, sections, sections_url: location.pathname})
      });
      if (qty !== 0) return new Response(JSON.stringify({status: 422, message: strings.cart_locked}), {status: 422});
      const updates = {};
      cart.items.filter(line => line.properties?._mf_group === group).forEach(line => { updates[line.key] = 0; });
      return fetch(`${root()}cart/update.js`, {
        method: 'POST', headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({updates, sections, sections_url: location.pathname})
      });
    }
  };
  window.MaxFreshPersonalization = api;
  class Personalization extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      Object.assign(strings, JSON.parse(this.querySelector('[data-mf-strings]').textContent));
      this.panel = this.querySelector('[data-mf-panel]');
      this.fields = this.querySelector('[data-mf-fields]');
      this.toggle = this.querySelector('[data-mf-toggle]');
      this.defaultFooter = this.querySelector('[data-mf-footer-text]')?.textContent || '';
      this.active = false;
      this.saved = null;
      this.values = [];
      this.cartResolved = false;
      this.cartTarget = null;
      this.lookupFailed = false;
      this.existingPaid = this.dataset.paid === 'true';
      const unitPrice = this.querySelector('[data-mf-unit-price]');
      if (unitPrice && this.price()) unitPrice.textContent = `+ ${this.money(this.price())}`;
      this.onClick = event => {
        if (event.target.closest('[data-mf-toggle]')) {
          this.openPersonalization();
          return;
        }
        if (event.target.closest('[data-mf-remove]')) this.removePersonalization();
        if (event.target.closest('[data-mf-save]')) {
          if (this.save() && this.dataset.action === 'add') {
            if (this.dataset.cartKey) api.attach(this);
            else api.add(document.getElementById(this.dataset.form));
          }
        }
      };
      this.addEventListener('click', this.onClick);
      this.querySelector('[data-mf-target]')?.addEventListener('change', event => {
        this.selectCartTarget(this.candidates.find(item => item.key === event.target.value) || null);
      });
      if (new URL(location.href).searchParams.has('mf_personalize') && components()[0] === this) {
        queueMicrotask(() => this.openPersonalization(true));
      }
      this.addEventListener('input', () => {
        this.values = [...this.fields.querySelectorAll('input')].map(input => input.value);
        this.fields.querySelectorAll('input').forEach(input => {
          const count = input.closest('label')?.querySelector('[data-mf-count]');
          if (count) count.textContent = `${input.value.length}/${input.maxLength}`;
        });
        this.invalidate();
      });
      this.quantityEvent = event => {
        if (event.target.closest('.product-info')?.contains(this) || event.target.closest('[id*="sticky"]')) {
          setTimeout(() => this.refresh(), 0);
        }
      };
      document.addEventListener('input', this.quantityEvent);
      document.addEventListener('change', this.quantityEvent);
      document.addEventListener('click', this.quantityEvent);
    }
    disconnectedCallback() {
      document.removeEventListener('input', this.quantityEvent);
      document.removeEventListener('change', this.quantityEvent);
      document.removeEventListener('click', this.quantityEvent);
    }
    syncPayment() {
      this.closest('.product-info')?.classList.toggle('mf-personalized', this.active);
    }
    variantId() {
      if (this.dataset.cartKey) return Number(this.dataset.variant);
      const form = document.getElementById(this.dataset.form);
      return Number(form ? new FormData(form).get('id') : 0);
    }
    async openPersonalization(scroll = false) {
      if (this.busy) return;
      this.active = true;
      this.panel.hidden = false;
      this.toggle.setAttribute('aria-expanded', 'true');
      this.syncPayment();
      this.refresh();
      await this.lookupCart();
      if (scroll) this.scrollIntoView({block: 'center', behavior: 'smooth'});
      this.fields.querySelector('input')?.focus();
    }
    async lookupCart() {
      this.setBusy(true, strings.checking_cart);
      try {
        const variant = this.variantId();
        const cart = await api.readCart();
        if (variant !== this.variantId()) throw new Error(strings.cart_changed);
        this.candidates = cart.items.filter(item => Number(item.variant_id || item.id) === variant && item.quantity > 0 && !['fee', 'gift'].includes(item.properties?._mf_role));
        const explicit = this.dataset.cartKey || new URL(location.href).searchParams.get('mf_personalize');
        let selected = explicit ? this.candidates.find(item => item.key === explicit) : this.candidates.find(item => item.key === this.cartTarget?.key) || this.candidates.find(item => !item.properties?._mf_group) || this.candidates[0];
        if (!selected && this.dataset.cartKey) {
          selected = this.dataset.group ? this.candidates.find(item => item.properties?._mf_group === this.dataset.group) : (this.candidates.length === 1 ? this.candidates[0] : undefined);
        }
        if (explicit && !selected) throw new Error(strings.cart_changed);
        if (this.dataset.cartKey && selected) this.dataset.cartKey = selected.key;
        this.cart = cart;
        this.cartResolved = true;
        this.lookupFailed = false;
        const select = this.querySelector('[data-mf-target]');
        const wrap = this.querySelector('[data-mf-target-wrap]');
        if (select) {
          select.replaceChildren();
          this.candidates.forEach((item, i) => {
            const option = document.createElement('option');
            option.value = item.key;
            option.textContent = `${i + 1}. ${item.variant_title || item.product_title || item.title || ''} · ${item.quantity} ${strings.items}`;
            select.append(option);
          });
          if (selected) select.value = selected.key;
        }
        if (wrap) wrap.hidden = this.candidates.length < 2;
        this.selectCartTarget(selected || null);
      } catch (error) {
        this.lookupFailed = true;
        this.panel.hidden = false;
        this.showError(error.message || strings.check_cart);
      } finally { this.setBusy(false); }
    }
    selectCartTarget(target) {
      this.cartTarget = target;
      this.existingPaid = !!(target?.properties?._mf_group && this.cart?.items.some(item => item.properties?._mf_group === target.properties._mf_group && item.properties?._mf_role === 'fee'));
      this.values = target ? Array.from({length: target.quantity}, (_, i) => target.properties?.[`Name ${i + 1}`] || '') : this.values;
      this.qty = null;
      this.refresh();
      this.updateCartContext();
    }
    updateCartContext() {
      if (this.dataset.cartKey) {
        (this.querySelector('[data-mf-toggle-label]') || this.toggle.firstChild).textContent = this.existingPaid ? strings.cart_edit : strings.cart_add;
        const price = this.querySelector('[data-mf-cart-price]');
        if (price) price.hidden = this.existingPaid;
        const savedNames = this.querySelector('[data-mf-cart-names]');
        if (savedNames) {
          savedNames.hidden = !this.existingPaid;
          const names = this.saved || Array.from({length: this.cartTarget?.quantity || 0}, (_, i) => this.cartTarget?.properties?.[`Name ${i + 1}`] || '');
          savedNames.textContent = `${strings.cart_saved_names}: ${names.join(', ')}`;
        }
      }
      const note = this.querySelector('[data-mf-existing-note]');
      if (note) {
        note.hidden = !this.cartTarget;
        note.textContent = this.existingPaid ? strings.paid_note : `${this.cartTarget?.quantity || ''} ${strings.items}. ${strings.existing_note}`;
      }
      const footer = this.querySelector('[data-mf-footer-text]');
      if (footer) footer.textContent = this.cartTarget ? (this.existingPaid ? strings.paid_footer : strings.fee_only_footer) : this.defaultFooter;
      const save = this.querySelector('[data-mf-save]');
      if (save && !this.busy) (save.querySelector('[data-mf-save-label]') || save).textContent = this.saveLabel();
    }
    saveLabel() {
      if (this.dataset.action !== 'add') return strings.save;
      return this.cartTarget ? (this.existingPaid ? strings.update_names : strings.save_existing) : strings.save_add;
    }
    price() {
      const amount = Number(this.dataset.price);
      return Number.isSafeInteger(amount) && amount > 0 ? amount : 0;
    }
    total() {
      return this.price() * (this.dataset.mode === 'per_group' ? 1 : this.qty);
    }
    money(cents) {
      return new Intl.NumberFormat('en-IN', {style: 'currency', currency: this.dataset.currency || 'INR', minimumFractionDigits: cents % 100 ? 2 : 0, maximumFractionDigits: 2}).format(cents / 100);
    }
    setBusy(busy, label = strings.adding) {
      this.busy = busy;
      this.setAttribute('aria-busy', String(busy));
      this.querySelectorAll('button').forEach(button => { button.disabled = busy; });
      this.fields.querySelectorAll('input').forEach(input => { input.readOnly = busy; });
      const save = this.querySelector('[data-mf-save]');
      save.disabled = busy || !this.dataset.fee || this.lookupFailed;
      const select = this.querySelector('[data-mf-target]');
      if (select) select.disabled = busy;
      (save.querySelector('[data-mf-save-label]') || save).textContent = busy ? label : this.saveLabel();
    }
    quantity() {
      if (this.cartTarget) return this.cartTarget.quantity;
      if (this.dataset.cartKey) return Number(this.dataset.quantity || 1);
      const form = document.getElementById(this.dataset.form);
      return Number(form ? new FormData(form).get('quantity') || 1 : 1);
    }
    refresh(qty = this.quantity()) {
      if (!this.active) return;
      if (!Number.isInteger(qty) || qty < 1 || qty > 100) {
        this.invalidate();
        this.fields.replaceChildren();
        this.querySelector('[data-mf-total]').textContent = '';
        this.showError(strings.invalid_quantity);
        this.qty = null;
        return;
      }
      if (this.qty === qty) return;
      this.qty = qty;
      this.invalidate();
      this.fields.replaceChildren();
      for (let index = 0; index < qty; index++) {
        const label = document.createElement('label');
        label.className = 'mf-personalization__field';
        const caption = document.createElement('span');
        caption.className = 'mf-personalization__field-label';
        const number = document.createElement('span');
        number.className = 'mf-personalization__field-number';
        number.textContent = String(index + 1).padStart(2, '0');
        caption.append(number, document.createTextNode(`${strings.name} ${index + 1}`));
        label.append(caption);
        const input = document.createElement('input');
        input.type = 'text';
        input.maxLength = Number(this.dataset.max) || 20;
        input.autocomplete = 'off';
        input.placeholder = strings.placeholder;
        input.value = this.values[index] || '';
        input.required = !this.dataset.cartKey;
        input.setAttribute('aria-required', 'true');
        const shell = document.createElement('span');
        shell.className = 'mf-personalization__input-shell';
        const icon = this.querySelector('[data-mf-field-icon]');
        if (icon) shell.append(icon.content.cloneNode(true));
        const count = document.createElement('span');
        count.className = 'mf-personalization__count';
        count.setAttribute('data-mf-count', '');
        count.setAttribute('aria-hidden', 'true');
        count.textContent = `${input.value.length}/${input.maxLength}`;
        shell.append(input, count);
        label.append(shell);
        this.fields.append(label);
      }
      this.querySelector('[data-mf-total]').textContent = `${this.money(this.total())}`;
      this.querySelector('[data-mf-error]').hidden = true;
      this.panel.hidden = false;
      this.toggle.setAttribute('aria-expanded', 'true');
    }
    invalidate() {
      this.saved = null;
      this.querySelector('[data-mf-summary]').hidden = true;
    }
    showError(message) {
      const error = this.querySelector('[data-mf-error]');
      error.textContent = message;
      error.hidden = false;
    }
    save() {
      if (this.busy) return false;
      this.refresh();
      if (!this.qty) return false;
      if (!this.dataset.fee || this.price() <= 0) {
        this.showError(strings.price_error);
        return;
      }
      const inputs = [...this.fields.querySelectorAll('input')];
      const invalid = inputs.find(input => !input.value.trim() || !input.checkValidity());
      if (invalid) {
        this.showError(strings.required);
        invalid.focus();
        return;
      }
      this.saved = inputs.map(input => input.value.trim());
      this.values = this.saved.slice();
      this.querySelector('[data-mf-error]').hidden = true;
      const summary = this.querySelector('[data-mf-summary]');
      (summary.querySelector('[data-mf-summary-text]') || summary).textContent = `${strings.summary}: ${this.saved.join(', ')} · ${this.money(this.total())}. ${strings.checkout_hint}`;
      summary.hidden = false;
      this.panel.hidden = true;
      this.toggle.setAttribute('aria-expanded', 'false');
      (this.querySelector('[data-mf-toggle-label]') || this.toggle.firstChild).textContent = `${strings.edit} `;
      return true;
    }
    removePersonalization() {
      this.cartTarget = null;
      this.cartResolved = false;
      this.lookupFailed = false;
      this.existingPaid = false;
      this.qty = null;
      this.active = false;
      this.saved = null;
      this.panel.hidden = true;
      this.querySelector('[data-mf-summary]').hidden = true;
      this.toggle.setAttribute('aria-expanded', 'false');
      (this.querySelector('[data-mf-toggle-label]') || this.toggle.firstChild).textContent = this.dataset.cartKey ? (this.dataset.paid === 'true' ? strings.cart_edit : strings.cart_add) : `${strings.button} `;
      this.syncPayment();
      this.toggle.focus();
    }
  }
  customElements.define('mf-personalization', Personalization);
  document.addEventListener('click', event => {
    const button = event.target.closest('button[name="add"], input[name="add"]');
    const form = button?.form;
    if (!form || !find(form)?.active) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    api.add(form);
  }, true);
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!find(form)?.active) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    api.add(form);
  }, true);
})();
